const $window = $(window);
// const breakPoint = 767;
const breakPoint = 1199;

let resizeFlag = false;
let windowWidth = $window.width();
let windowHeight = $window.height();
//const bodyLimitHeight = (windowHeight - 185) * 0.88;

let url = location.href;

//ローディング
const loading = () => {
  const $target = $('#sw-Loading');
  window.addEventListener('load',function(){
    setTimeout( () => {
      $target.fadeOut(600);
    }, 1000);
  });
  setTimeout( () => {
    $target.fadeOut(600);
  }, 15000);
};

//ページ内リンクのアニメーション
const anchorScroll = () => {
  const $anchor = $('a[href^=#]');
  $anchor.click(function () {
    const speed = 1000;
    const href = $(this).attr('href');
    const target = $(href == '#' || href == '' ? 'html' : href);
    const position = target.offset().top;
    $('html, body').animate({
      scrollTop: position
    }, speed, 'swing');
    return false;
  });
};

//SPヘッダーの開閉
const spHeaderToggle = () => {
  //config
  const $headerContent = $('#st-Header_Nav');
  //open
  const $headerOpen = $('#js-Header_Trigger');
  $headerOpen.on('click', function(){
    $headerContent.addClass('closed').addClass('opened');
    return false;
  });
  //close
  const $headerClose = $('#js-Header_Close');
  $headerClose.on('click', function(){
    $headerContent.removeClass('opened').addClass('closed');
    return false;
  });
};

//外部ページからのアンカー
const externalAnchor = () => {
  const url = $(location).attr('href');
  if (url.indexOf("?id=") == -1) {
  } else {
    const url_sp = url.split("?id=");
    const hash = '#' + url_sp[url_sp.length - 1];
    const tgt = $(hash);
    let pos;
    if(windowWidth > breakPoint){
      pos = tgt.offset().top - 177;
    }else{
      pos = tgt.offset().top - (windowWidth * 0.24609375);
    }
    $("html, body").animate({
      scrollTop: pos
    }, 1000, "swing");
  }
}

//YouTubeのモーダル
const youtubeModal = () => {
  const $modal = $('.sw-Movie');
  const $content = $('.sw-Movie_Content');
  const $youtube = $('.js-Youtube');
  // open
  $youtube.on('click', function(){
    const dataID = $(this).attr('data-youtube');
    //iframe append
    $content.append('<iframe width="900" height="506" src="https://www.youtube.com/embed/'+dataID+'?rel=0&autoplay=1" frameborder="0"></iframe>');
    // fadeIn
    $modal.stop().fadeIn(400);
    return false;
  });
  //close
  $('.sw-Movie_Overlay,.sw-Movie_Close').on('click', function(){
    $modal.stop().fadeOut(400, function(){
      $content.children().remove();
    });
  });
};


//export
export { loading, anchorScroll, spHeaderToggle, externalAnchor, youtubeModal };


// WEBPACK FOOTER //
// ./src/assets/js/include/module.js